import * as React from 'react';

import Icon from 'components/atoms/Icon';

type InfoTextProps = {
	text: string;
	icon?: string;
};

const InfoText = ({ text, icon }: InfoTextProps) => (
	<div className="a-info-text">
		<span className="a-info-text__icon">
			<Icon iconName={icon || 'workout'} />
		</span>
		<span className="a-info-text__label">{text}</span>
	</div>
);

export default InfoText;
